import type { Intervention } from '@seen/core/models/care-plans/intervention'
import {
  IDT_ROLE_OPTIONS,
  type IDTRole,
} from '@seen/core/models/care-teams/constants'
import type { JSX } from 'react'
import { MultiSelect } from '#src/components/core/combobox/MultiSelect.tsx'
import { ResourceFieldForm } from '#src/components/core/form/ResourceFieldForm.tsx'
import { useInterventionIsEditable } from '#src/hooks/useInterventionIsEditable.ts'

interface InterventionRolesProps {
  intervention: Intervention
}

export function InterventionRoles({
  intervention,
}: InterventionRolesProps): JSX.Element | null {
  const isEditable = useInterventionIsEditable(intervention)
  return (
    <ResourceFieldForm<Intervention, IDTRole[]>
      instance={intervention}
      valueFn={(intervention) => intervention.idtRoles}
      patchFn={(intervention, values) => {
        intervention.idtRoles = values
      }}
      render={({ field }) => (
        <MultiSelect
          options={IDT_ROLE_OPTIONS}
          variant="ghost"
          className="w-full"
          placeholder="Add roles..."
          {...field}
          value={field.value}
          onChange={(values) => {
            field.onChange(values)
          }}
          disabled={!isEditable}
          badgeLabel={(option) => option.value}
        />
      )}
    />
  )
}
